import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Popover } from 'antd';
import { InternalAccountModal } from 'widgets/roles-modal/ui/InternalAccountModal/InternalAccountModal';

import { SetupApplication } from 'features/application/install/ui/SetupApplication/SetupApplication';
import { ModalFooter } from 'shared/ui/ModalFooter';
import { MpButton } from 'shared/ui/MpButton';
import { MpLink } from 'shared/ui/MpLink';
import { MpText } from 'shared/ui/MpText';

interface Props {
	disabled: boolean;
	applicationId: string;
	handleInstall: () => void;
	redirectUrl: string;
	internalAccount: boolean;
}

export const SetupFreeTariff: FC<Props> = ({
	disabled,
	applicationId,
	handleInstall,
	redirectUrl,
	internalAccount,
}) => {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const closeModal = (): void => {
		setIsModalOpen(false);
	};

	const openModal = (): void => {
		setIsModalOpen(true);
	};

	const authorizedFooter = [
		<ModalFooter key='1'>
			<span>
				<Button key='back' size='large' onClick={closeModal} block>
					{t(`Marketplace_Cancel`)}
				</Button>
			</span>
			<a
				key='login-link'
				href={`/privateapi/auth/externallogin?provider=mpoidc&returnUrl=${window.location.href}`}
			>
				<Button key='login' size='large' type='primary' block>
					{t(`Marketplace_Sign_Out_Dodo_IS`)}
				</Button>
			</a>
		</ModalFooter>,
	];

	if (internalAccount) {
		return (
			<div style={{ marginTop: `24px` }}>
				<MpButton size='large' fullWidth onClick={openModal}>
					{t(`Marketplace_Install`)}
				</MpButton>
				<Modal
					width={690}
					open={isModalOpen}
					onCancel={closeModal}
					className='roles-modal'
					footer={authorizedFooter}
				>
					<InternalAccountModal />
				</Modal>
			</div>
		);
	}
	if (disabled) {
		return (
			<Popover
				placement='bottom'
				content={
					<MpText style={{ width: `270px` }}>
						Для смены тарифа отмените текущую подписку в разделе{` `}
						<MpLink url='apps/my?tab=subscriptions' text={t(`Marketplace_Subscription_Management`)} />
					</MpText>
				}
			>
				<div style={{ marginTop: `24px` }}>
					<SetupApplication
						applicationId={applicationId}
						handleInstall={handleInstall}
						redirectUrl={redirectUrl}
						borderRadius={false}
						isLink
						disabled={disabled}
					/>
				</div>
			</Popover>
		);
	}

	return (
		<div style={{ marginTop: `24px` }}>
			<SetupApplication
				applicationId={applicationId}
				handleInstall={handleInstall}
				redirectUrl={redirectUrl}
				borderRadius
				isLink
				disabled={disabled}
			/>
		</div>
	);
};
